<script setup>
import moment from 'moment';
import fiveMixin from '@/composables/fiveMixin';
import TooltipButton from '@/components/tooltip/TooltipButton.vue';
import { addContentLogAPI } from '@/api/logServiceApi';

const props = defineProps({
  isMobileView: Boolean,
  isDailyFortuneLoading: Boolean,
  isDailyFortuneLoaded: Boolean,
  isDictionaryOpen: Boolean,
  dailyCustomObject: Object,
  selectedDayCellProps: Object,
});

const emit = defineEmits(['closeDrawer']);

const tooltipType = ref(null);

const { getColorFive } = fiveMixin();

const closeDrawer = () => emit('closeDrawer');

const toggleTooltip = (type) => {
  if (tooltipType.value === type) {
    tooltipType.value = null;  
  } else {
    tooltipType.value = type;
    addContentLogAPI({
      contentType: 'fc_luck_tooltip_opt3',
      option3: '헤더'
    });
  }
};
const closeTooltip = (event) => {
  tooltipType.value = null;
};
</script>

<template>
  <div class="df-drawer__header" :style="isMobileView ? 'width: 100vw' : ''">
    <div v-if="Object.keys(selectedDayCellProps).length !== 0" class="df-drawer__header-title">
      {{ moment(selectedDayCellProps?.day).format('YYYY년 MM월 DD일') }}
      <div v-if="selectedDayCellProps?.dayju && selectedDayCellProps?.handayju" class="df-drawer__header-ganji">
        <div class="ganji-txt" :class="getColorFive(selectedDayCellProps?.dayju[0])">{{ selectedDayCellProps?.handayju[0] }}</div>
        <div class="ganji-txt" :class="getColorFive(selectedDayCellProps?.dayju[1])">{{ selectedDayCellProps?.handayju[1] }}</div>
        (<div class="ganji-txt" :class="getColorFive(selectedDayCellProps?.dayju[0])">{{ selectedDayCellProps?.dayju[0] }}</div>
        <div class="ganji-txt" :class="getColorFive(selectedDayCellProps?.dayju[1])">{{ selectedDayCellProps?.dayju[1] }}</div>)
        일
      </div>
    </div>

    <div v-if="!isDailyFortuneLoading && isDailyFortuneLoaded && dailyCustomObject && dailyCustomObject['갑자의미']" class="df-drawer__header-content">
      {{ `${dailyCustomObject['갑자의미']['상징']} : ${dailyCustomObject['갑자의미']['의미']}` }}
    </div>

    <div
      v-if="!isDailyFortuneLoading && isDailyFortuneLoaded && dailyCustomObject"
      class="df-drawer__header-content-sm"
    >
      <TooltipButton
        :visible="tooltipType === 'header'"
        :customClass="{'tooltip-container-header': true}"
        @toggleTooltip="toggleTooltip('header')"
        @closeTooltip="closeTooltip"
      >
        <template #tooltip-pop__content>
          <div class="tooltip-pop__content">
            {{ `${dailyCustomObject['갑자의미']['상징']} : ${dailyCustomObject['갑자의미']['의미']}` }}
          </div>
        </template>
      </TooltipButton>
    </div>

    <button
      class="df-drawer__header-close"
      :class="{ hide: isDictionaryOpen }"
      @click="closeDrawer">
    </button>
  </div>
</template>